import { Helmet } from "react-helmet-async";
import { site } from "@/config/site";

const OG_IMAGE = `${site.url}/og-image.png`;

export const Seo = ({ title, description, path = "/", noindex = false, jsonLd = [], breadcrumb }) => {
  const canonical = `${site.url}${path}`;
  const ld = [...jsonLd];
  if (breadcrumb) {
    ld.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: `${site.url}/` },
        { "@type": "ListItem", position: 2, name: breadcrumb, item: canonical },
      ],
    });
  }
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};

export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: site.name,
  legalName: site.name,
  url: `${site.url}/`,
  logo: `${site.url}/logo.svg`,
  image: OG_IMAGE,
  description: site.tagline,
  email: site.email,
  telephone: site.phone,
  foundingDate: site.registrationDateISO,
  taxID: site.siren,
  vatID: site.vat,
  address: {
    "@type": "PostalAddress",
    streetAddress: site.address.street,
    postalCode: site.address.postalCode,
    addressLocality: site.address.cityDisplay,
    addressCountry: "FR",
  },
  founder: { "@type": "Person", name: site.president.fullName, jobTitle: site.president.title },
  areaServed: ["FR", "International"],
};
